import { create } from 'zustand'

export interface ISpeedStore {
  isEnabled: boolean
}

export const useSpeedStore = create<ISpeedStore>(() => ({
  isEnabled: false,
}))
